/* repo/stats */
import { fetch as fetchApi, isString } from "./api";
import { StatsCodec, Stats } from "../store/stats/types";
import { withDecoded, flattenData } from "./";

function mapToModel(data: object): Stats {
  return withDecoded(StatsCodec, data, decoded => ({
    ...decoded
  }));
}

export async function fetch(id: string | null, params?: {}): Promise<Stats> {
  return fetchApi({
    nestedResourcePath: ["stats"],
    id: id,
    params: params
  }).then(response =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}
